import service from '@/utils/server';

const modName='/bd/appointment/';
const contract ='int/contract/'
const purchOrder ='bd/purchOrder/'

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    responseType: 'blob',
    data
  });
};

export const getAppointmentDetail = data => {
  return service({
    url: modName + 'getAppointmentDetail/'+data,
    method: 'post',
  });
};

//下载合同订单模板
export const downloadContractTemplate = data=>{
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: contract + 'template/' + data.templateName,
    method: 'post',
    data
  });
}

//下载市场订单模板
export const downloadPurchOrderTemplate = data=>{
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: purchOrder + 'template/' + data.templateName,
    method: 'post',
    data
  });
}

export const importContractData = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  return service({
    ...config,
    url: contract + 'importData',
    method: 'post',
    data
  });
};

export const importPurchOrderData = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  return service({
    ...config,
    url: purchOrder + 'importData',
    method: 'post',
    data
  });
};

export const cancel = data => {
  return service({
    url: modName + 'cancel/'+data,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/appointment/api/index.js